import React from 'react';
import PropTypes from 'prop-types';
import { ReactSVG } from 'react-svg';
import { useSelector } from 'react-redux';
import { Icon } from '@modulor/react';
import Local from '../../Local/Local';
import NavigationBlock from '../NavigationBlock/NavigationBlock';
import NavigationLink from '../NavigationBlock/NavigationLink/NavigationLink';
import NavigationTitle from '../NavigationBlock/NavigationTitle/NavigationTitle';
import { useQueryCategories } from '../../../hooks/API/useQueryCategories';
import { categoryLogoSelector } from '../../../redux/reducers/app/configuration';
import { createMockEntitiesArray } from '../../../utils';
import { useAnalyticsScreenName } from '../../../hooks/useAnalyticsScreenName';
import {
  getCategoriesRoute,
  getCategoryDetailRoute,
} from '../../../utils/routes';
import { getCategoryLogoImagePath } from '../../../utils/imagePath';
import { getDataTestAttrs } from '../../../utils/testing-locators';
import { EVENT_ACTION } from '../../../constants/ga';
import { NAMESPACES } from '../../../constants/namespaces';
import { NAVIGATION_CATEGORIES } from '../../../constants/dataTestIds';
import {
  ANALYTICS_SCHEMA_URLS,
  ANALYTICS_SCREEN_AREAS,
  ANALYTICS_SCREEN_AREA_DETAILS,
} from '../../../constants/analytics';

const CategoriesNavigation = ({ limit, sectionIndex, className }) => {
  const screenName = useAnalyticsScreenName();
  const categoryLogo = useSelector(categoryLogoSelector);

  const { isLoading, data } = useQueryCategories({ _limit: limit });

  const collection = isLoading
    ? createMockEntitiesArray(limit)
    : data?.items ?? [];

  return (
    <NavigationBlock
      title={
        <NavigationTitle
          link={getCategoriesRoute()}
          title={<Local namespace={NAMESPACES.PAGES}>Categories</Local>}
          dataLayerEventData={{
            eventAction: EVENT_ACTION.NAV_CATEGORIES,
            section_index: sectionIndex,
          }}
          analyticsData={{
            schema: ANALYTICS_SCHEMA_URLS.ALL_CLASSIFICATION_CLICK,
            screen_name: screenName,
            screen_area: ANALYTICS_SCREEN_AREAS.SIDEBAR,
            screen_area_detail: ANALYTICS_SCREEN_AREA_DETAILS.ALL_CATEGORY,
            section_index: 1,
            position_index: 1,
          }}
        />
      }
      className={className}
      {...getDataTestAttrs(NAVIGATION_CATEGORIES)}
    >
      {collection?.map?.((category, index) => (
        <NavigationLink
          key={category.id}
          isLoading={isLoading}
          link={getCategoryDetailRoute(category.id)}
          icon={
            <ReactSVG
              src={getCategoryLogoImagePath(categoryLogo, category.id)}
              fallback={() => <Icon name="no_icon" />}
            />
          }
          title={
            <Local namespace={NAMESPACES.CATEGORY}>
              {category?.translationKey}
            </Local>
          }
          gameCount={category?.gameCount}
          dataLayerEventData={{
            eventAction: EVENT_ACTION.NAV_CATEGORY_ITEM,
            section_index: sectionIndex,
            position_index: index,
            category_id: category.id,
          }}
          analyticsData={{
            schema: ANALYTICS_SCHEMA_URLS.MORE_GAME_CLICK,
            screen_name: screenName,
            screen_area: ANALYTICS_SCREEN_AREAS.SIDEBAR,
            screen_area_detail: ANALYTICS_SCREEN_AREA_DETAILS.CATEGORY,
            event_detail: category.id,
            section_index: 1,
            position_index: index,
          }}
        />
      ))}
    </NavigationBlock>
  );
};

CategoriesNavigation.propTypes = {
  limit: PropTypes.number,
  sectionIndex: PropTypes.number,
};

CategoriesNavigation.defaultProps = {
  limit: 5,
  sectionIndex: 0,
};

export default CategoriesNavigation;
